webpackJsonp([195417598165561],{

/***/ 98:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _config = __webpack_require__(17);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Search = __webpack_require__(78);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Logo = __webpack_require__(37);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _HeaderStyles = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var light = _ref.light;
	  return _react2.default.createElement(
	    _HeaderStyles.StyledHeader,
	    null,
	    !light && _react2.default.createElement(
	      _HeaderStyles.HeadingWrap,
	      null,
	      _react2.default.createElement(
	        _HeaderStyles.Heading,
	        null,
	        _react2.default.createElement(_Logo2.default, { size: 32 }),
	        'toomanykiwis'
	      ),
	      _react2.default.createElement(
	        _HeaderStyles.TagLine,
	        null,
	        _config2.default.TAG_LINE
	      )
	    ),
	    _react2.default.createElement(_Search2.default, null)
	  );
	};
	
	// Components
	
	
	Header.propsTypes = {
	  light: _propTypes2.default.bool
	};
	
	Header.defaultProps = {
	  light: true
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HeadingWrap = exports.TagLine = exports.Heading = exports.StyledHeader = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  padding: 1rem 2rem;\n  position: relative;\n'], ['\n  width: 100%;\n  padding: 1rem 2rem;\n  position: relative;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  justify-content: flex-start;\n  display: flex;\n  align-items: center;\n  font-size: 4rem;\n\n  > span {\n    font-size: 2rem;\n    position: relative;\n    top: 6px;\n    left: 1px;\n  }\n\n  > div {\n    margin: 0 8px 0 0;\n    display: inline-block;\n    position: relative;\n\n    > svg {\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n  }\n'], ['\n  justify-content: flex-start;\n  display: flex;\n  align-items: center;\n  font-size: 4rem;\n\n  > span {\n    font-size: 2rem;\n    position: relative;\n    top: 6px;\n    left: 1px;\n  }\n\n  > div {\n    margin: 0 8px 0 0;\n    display: inline-block;\n    position: relative;\n\n    > svg {\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin: 0 0 0 3.9rem;\n'], ['\n  margin: 0 0 0 3.9rem;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  padding: 1rem 0 2rem;\n'], ['\n  padding: 1rem 0 2rem;\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledHeader = exports.StyledHeader = _styledComponents2.default.header(_templateObject);
	
	var Heading = exports.Heading = _styledComponents2.default.h1(_templateObject2);
	
	var TagLine = exports.TagLine = _styledComponents2.default.p(_templateObject3);
	
	var HeadingWrap = exports.HeadingWrap = _styledComponents2.default.hgroup(_templateObject4);

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Header = __webpack_require__(43);
	
	var _Header2 = _interopRequireDefault(_Header);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Header2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(272);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _reactHelmet = __webpack_require__(33);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Header = __webpack_require__(45);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _utils = __webpack_require__(18);
	
	var _DietTemplateStyles = __webpack_require__(326);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Styles
	
	
	// Components
	var SourcesComponent = function SourcesComponent(_ref) {
	  var name = _ref.name;
	  return _react2.default.createElement(
	    'h3',
	    null,
	    'Here are the sources of ',
	    name
	  );
	};
	
	function Template(_ref2) {
	  var data = _ref2.data;
	  var markdownRemark = data.markdownRemark; // data.markdownRemark holds our post data
	
	  var frontmatter = markdownRemark.frontmatter,
	      html = markdownRemark.html;
	  var altname = frontmatter.altname,
	      path = frontmatter.path,
	      name = frontmatter.name,
	      tags = frontmatter.tags;
	
	  // placeholders in markdown for dynamic components
	
	  var compiledSources = _server2.default.renderToStaticMarkup(_react2.default.createElement(SourcesComponent, { name: name }));
	
	  var enhancedHTML = html.replace(/\$NAME/g, name).replace('$SOURCES', compiledSources);
	
	  return _react2.default.createElement(
	    _DietTemplateStyles.StyledWrapper,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'What is ' + name + '?',
	      meta: [{ name: 'description', content: 'What is ' + name + '?' }, { name: 'keywords', content: name + ',' + tags + ',nutrient,health' }] }),
	    _react2.default.createElement(_Header2.default, { backLink: true }),
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: enhancedHTML } })
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BackLinkWrap = exports.HeaderSection = exports.StyledWrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 0 0 4rem 0;\n  background: white;\n\n  > section {\n    padding: 1rem 2rem;\n  }\n'], ['\n  padding: 0 0 4rem 0;\n  background: white;\n\n  > section {\n    padding: 1rem 2rem;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 8rem 1rem;\n  margin: 5rem 0 4rem 0;\n  position: relative;\n'], ['\n  padding: 8rem 1rem;\n  margin: 5rem 0 4rem 0;\n  position: relative;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  display: block;\n  width: 100px;\n  font-size: 2rem;\n  line-height: 2rem;\n  padding: 1rem;\n  top: -5rem;\n  left: 0;\n  border-bottom: 1px solid black;\n\n  > a {\n    color: black;\n  }\n'], ['\n  position: absolute;\n  display: block;\n  width: 100px;\n  font-size: 2rem;\n  line-height: 2rem;\n  padding: 1rem;\n  top: -5rem;\n  left: 0;\n  border-bottom: 1px solid black;\n\n  > a {\n    color: black;\n  }\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styleUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledWrapper = exports.StyledWrapper = _styledComponents2.default.div(_templateObject);
	
	var HeaderSection = exports.HeaderSection = _styledComponents2.default.section(_templateObject2);
	
	var BackLinkWrap = exports.BackLinkWrap = _styledComponents2.default.div(_templateObject3);

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-diet-template-diet-template-js-069fa814ead8896be3a1.js